import { toast } from 'sonner';

const toastOptions = {
  duration: 4000,
  position: 'top-center' as const,
};

export const toastSuccess = (message: string) => toast.success(message, toastOptions);
export const toastInfo = (message: string) => toast.info(message, toastOptions);
export const toastError = (message: string) => toast.error(message, toastOptions);
